import React, { useState } from 'react';
import {Collapse,message, Spin, Table, Typography } from 'antd';
import styles from './Count.module.css';
import { getWorkload } from '../../api/Api';
import { useHistory } from 'react-router-dom';
import { QueryPanel } from './QueryPanel';
export const Workload: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [activePanel,setActivePanel] = useState(["1"]);
  const [loading,setLoading]=useState(false);
  const history = useHistory();
  
  const doQuery = async ( checkDateBegin:string,
    checkDateEnd:string,
    ageBegin:string,
    ageEnd:string,
    schoolName:string,
    checkName:string,
    cat:number[],
    result:string[]) => {
      setLoading(true);
    let res: any = await getWorkload( checkDateBegin,checkDateEnd,ageBegin,ageEnd,schoolName,checkName,cat,result);
    if(typeof data === "undefined"){
      setLoading(false);
      history.push("/");      
    }
    let _data: any[] = [], _total = 0;
    res.forEach(d => {
      let _item: any = { Type: d.type, key: d.type, Count: d.count };
      _data.push(_item);
      _total += d.count;
    });
    if(_data.length === 0){
      message.info("没有符合查询条件的数据!");
      setLoading(false);
        return;
    }
    setData(_data);
    setTotal(_total);
    setActivePanel(["2"]);
    setLoading(false);
  }
  const panelChange =  (key) => {
    //console.log(key);
    setActivePanel(key);
  }

  const buildColumns = () => {
    return [
      {
        title: '统计日期',
        dataIndex: 'Type',
        key: 'Type',
        width: 200,
      },
      {
        title: '工作量',
        dataIndex: 'Count',
        key: 'Count',
        width: 200,
      },
    ];

  };
  return (
    <div>
       {loading && <Spin />}
      {!loading && (<>
      <Collapse activeKey={activePanel} onChange={panelChange}>
        <Collapse.Panel header="查询条件" key="1">
        <div className={styles["querypage"]} >
            <QueryPanel doQuery={doQuery}/>
          </div>
        </Collapse.Panel>

        <Collapse.Panel header="工作量统计报表" key="2">
          <Typography.Title level={5}>工作量合计为：{total}</Typography.Title>
          <Table
            className={styles["table"]}
            bordered
            pagination={false}
            columns={buildColumns()}
            dataSource={data}
          />
        </Collapse.Panel>
      </Collapse>
      </>)}
    </div>
  )
};

